module.exports = __webpack_public_path__ + "static/media/content-1.17165fec.png";